export const AWS_CONFIG = {
  /* UserPool ID */
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  /* Cognito Client ID */
  userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
  /* Cognito Region */
  region: process.env.REACT_APP_COGNITO_REGION,
  /* 
    /* 
  /* 
    **
    For OAuth configuration, If you wanna use a 3th 
    factor authentication, like facebook, google or any other 
    you need to have that configuration in your AWS Cognito account 
    **
    */
  oauth: {
    /* Application domain */
    domain: process.env.REACT_APP_COGNITO_DOMAIN,

    /* Redirect url executing sign in */
    redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN,

    /* Redirect url executing sign out */
    redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT,

    /* 
    **
    'code' for Authorization code grant, 
    'token' for Implicit grant
    Note that REFRESH token will only be generated when the responseType is code 
    **
    */
    responseType: "code",

    /* Authorized scopes 'phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin' */
    scope: ["phone", "email"],
  },

  /* User Pool ID */
  /* federationTarget: "", */
};

export const AWS_CREDENTIALS = {
  accessKeyId: process.env.REACT_APP_COGNITO_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_COGNITO_SECRET_ACCESS_KEY,
};
